import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
    if (onAccept) {
      onAccept();
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
    if (onDecline) {
      onDecline();
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <div className="cookie-consent-icon">
            <i className="fas fa-cookie-bite"></i>
          </div>
          <div className="cookie-consent-text">
            <h3>Cookie Consent</h3>
            <p>
              We use cookies to track usage and provide authentication services. 
              By continuing, you agree to our use of cookies. 
              <a href="/privacy" target="_blank" rel="noopener noreferrer"> Learn more</a>
            </p>
          </div>
        </div>
        <div className="cookie-consent-actions">
          <button 
            className="cookie-consent-button cookie-consent-accept"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button 
            className="cookie-consent-button cookie-consent-decline"
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;





